import { Field } from "formik"
import { useState } from "react";

export default function VoucherInputs({ values, setFieldValue, errors}) {

  const validateDatosVoucher = (value, values) => {

    let error;

    if(values.voucher > 0){
      if(!value){
        error = 'Falta un campo'
     }
    }

    return error

  }

  const isError = (errors) => {
    const { noBoleta, fechaBoleta } = errors
    const camposVoucher = {noBoleta, fechaBoleta}
    
    const errorsVoucher = Object.entries(camposVoucher).reduce((acc, [key, value]) => {
        if (value) {
            acc.push(key)
        }

        return acc
    }, [])

    if(errorsVoucher.length !== 0){
      return {
        ok: false,
        msg: 'Ingrese todos los campos del voucher'
      }
    }

    return {
      ok: true
    }
  }

  const Error = isError(errors)

  const [date, setDate] = useState('')
  const handleDate = (e) => { 
    setDate(e.target.value)
    setFieldValue('fechaBoleta', e.target.value.split('-').join('') )
  }

    return (
      <>
        <div className="col-span-6">
          <fieldset>
            <legend className="block text-sm font-medium text-grisMira">Datos del voucher</legend>
            <div className="mt-1 bg-white -space-y-px rounded-md shadow-sm">
              <div>
                <label className="sr-only">
                  No. Boleta
                </label>
                <Field
                  validate={(value) => validateDatosVoucher(value, values) }
                  id="noBoleta"
                  name="noBoleta"
                  type="text"
                  placeholder="Número de voucher"
                  className="relative block w-full rounded-none rounded-t-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                />
              </div>
              <div>
                <label htmlFor="fecha" className="sr-only">
                  Fecha de Boleta
                </label>
                <Field
                  validate={(value) => validateDatosVoucher(value, values) }
                  onChange={(e) => handleDate(e)}
                  value={date}
                  type="date"
                  name="fechaBoleta"
                  id="fechaBoleta"
                  className="cursor-pointer relative block w-full rounded-none rounded-b-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                  placeholder="Fecha de voucher"
                />
              </div>
            </div>
          </fieldset>
        </div>
        {
          !Error.ok ?
            <p className="col-span-full w-full text-center block text-sm font-semibold text-red-500">{Error.msg}</p>
          : null
        }
      </>
    )
  }